import { render, staticRenderFns } from "./DistributorsHeader.vue?vue&type=template&id=07bd92e0&"
import script from "./DistributorsHeader.vue?vue&type=script&lang=js&"
export * from "./DistributorsHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports